<template>
  <div class="factories">
    <mainmenu selected="factories"></mainmenu>

    <div class="factories-shell">
      <div class="factories-toolbar">
        <h1>{{ $t("factories.page_title") }}</h1>
        <el-button type="primary" icon="el-icon-plus" @click='add_item()'>{{ $t("add_item") }}</el-button>
      </div>

      <div class="factories-filters">
        <div class="filters-title">{{ $t("factories.filters") }}</div>
        <el-input
          class="filter-control filter-search"
          v-model="Filters.Search"
          :placeholder="$t('factories.search_placeholder')"
          prefix-icon="el-icon-search"
          clearable
          @input="on_filter_input"
          @clear="apply_filters">
        </el-input>
        <el-select class="filter-control" v-model="Filters.Country" :placeholder="$t('factories.country')" clearable filterable @change="apply_filters">
          <el-option v-for="item in FilterOptions.Countries" :key="item" :label="country_label(item)" :value="item"></el-option>
        </el-select>
        <el-button class="reset-filters" icon="el-icon-refresh-left" @click="reset_filters">{{ $t("reset") }}</el-button>
      </div>

      <div class="factories-card">
      <el-table
        class="factories-table"
        :data="Results"
        style="width: 100%"
        :max-height="TableMaxHeight"
        stripe
        v-loading="tableLoadingVisible">
        <el-table-column :label="$t('factories.country')" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ country_label(scope.row.Country) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ShortCode" :label="$t('factories.code')" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Email" :label="$t('factories.email')" min-width="240" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Address" :label="$t('factories.address')" min-width="280" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" :label="$t('operations')" width="145" align="right" header-align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.Id != '-1'" class="operation-actions">
              <el-button @click="edit_item(scope.row)" type="text" size="mini">{{ $t("edit") }}</el-button>
              <el-button @click="delete_item(scope.row)" type="text" size="mini" class="danger-action">{{ $t("delete") }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

        <div class="factories-pagination">
          <el-pagination
          background
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "total, prev, pager, next">
          </el-pagination>
        </div>
      </div>
    </div>
    <factory-dialog ref="item_dialog" @save='refresh_info' />
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import FactoryDialog from "./../views/dialogs/FactoryDialog";
import { countryLabel } from "./../utils/countries";

export default {
  name: "factories",
  components: {
    "mainmenu": MainMenu,
    "factory-dialog": FactoryDialog
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: { Search: "", Country: "" },
      FilterOptions: { Countries: [] },
      TableMaxHeight: 620,
      ResizeTimer: null,
      FilterTimer: null,
      RequestSerial: 0,
      PaginationInfo: { Page: 1, PerPage: 20, RowCount: 0, PageSizes: [20] }
    }
  },
  methods: {
    country_label: function(country) {
      return countryLabel(this, country);
    },
    get_default_filters: function() {
      return { Search: "", Country: "" };
    },
    get_visible_page_size: function() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 900;
      var cardElement = this.$el ? this.$el.querySelector(".factories-card") : null;
      var cardTop = cardElement ? cardElement.getBoundingClientRect().top : 205;
      var paginationHeight = 52;
      var bottomPadding = 18;
      var availableTableHeight = Math.max(320, viewportHeight - cardTop - paginationHeight - bottomPadding);
      this.TableMaxHeight = availableTableHeight;

      var rowHeight = 33;
      var tableHeaderHeight = 44;
      var visibleRows = Math.floor((availableTableHeight - tableHeaderHeight) / rowHeight);
      return Math.max(10, Math.min(22, visibleRows));
    },
    fit_page_size_to_viewport: function() {
      var pageSize = this.get_visible_page_size();
      this.PaginationInfo.PageSizes = [pageSize];
      if( this.PaginationInfo.PerPage != pageSize )
      {
        this.PaginationInfo.PerPage = pageSize;
        return true;
      }
      return false;
    },
    on_window_resize: function() {
      clearTimeout(this.ResizeTimer);
      this.ResizeTimer = setTimeout(() => {
        if( this.fit_page_size_to_viewport() )
        {
          this.PaginationInfo.Page = 1;
          this.refresh_info();
        }
      }, 150);
    },
    apply_filters: function() {
      this.PaginationInfo.Page = 1;
      this.refresh_info();
    },
    on_filter_input: function() {
      clearTimeout(this.FilterTimer);
      this.FilterTimer = setTimeout(() => {
        this.apply_filters();
      }, 300);
    },
    reset_filters: function() {
      clearTimeout(this.FilterTimer);
      this.Filters = this.get_default_filters();
      this.apply_filters();
    },
     refresh_info: function() {
       this.fit_page_size_to_viewport();
       var requestSerial = ++this.RequestSerial;
       this.tableLoadingVisible = true;
       this.$http
          .post('factories/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            if(requestSerial !== this.RequestSerial) return;
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
              this.FilterOptions = response.body.FilterOptions || this.FilterOptions;
            } else {
              this.$router.push("/");
            }
          })
          .catch(function() {
            if(requestSerial !== this.RequestSerial) return;
            this.tableLoadingVisible = false;
            this.$message.error("Could not load factories. Please try again.");
          });
    },
    add_item: function(){
      this.$refs.item_dialog.show_me();
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    delete_item: function(item){
       this.$confirm( this.$t("confirm_delete"), this.$t("warning_title"), { 
         confirmButtonText: this.$t("confirm"), 
         cancelButtonText: this.$t("cancel"), 
         type: 'warning'
        }).then(() => {
          this.tableLoadingVisible = true;
          this.$http
              .post('factories/delete_item',  { object: item } )
              .then(function (response) {
                this.tableLoadingVisible = false;
                if( settings.verify_response(response, this.$rights)) {
                  this.refresh_info();
                } else {
                  this.$router.push("/");
                }
              });
        }).catch(()=>{ });
    }
  },
  mounted: function() {
    this.fit_page_size_to_viewport();
    window.addEventListener('resize', this.on_window_resize);
    this.refresh_info();
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.on_window_resize);
    clearTimeout(this.ResizeTimer);
    clearTimeout(this.FilterTimer);
  }
};
</script>

<style lang="less" scoped>
.factories-shell {
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 18px 18px;
}

.factories-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid rgba(31, 73, 95, 0.14);
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(19, 55, 73, 0.10);

  h1 {
    margin: 0;
    color: #172b38;
    font-size: 30px;
    line-height: 1.1;
    font-weight: 700;
  }

  .el-button {
    height: 36px;
    padding: 0 16px;
    border-color: #157c91;
    background: #178da5;
    box-shadow: 0 6px 14px rgba(23, 141, 165, 0.22);
  }
}

.factories-filters {
  display: grid;
  grid-template-columns: auto minmax(240px, 1.4fr) minmax(170px, 0.7fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid rgba(31, 73, 95, 0.12);
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(19, 55, 73, 0.08);
}

.filters-title {
  color: #344955;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.filter-control {
  width: 100%;

  /deep/ .el-input__inner {
    height: 34px;
    border-color: #d9e4ea;
    color: #3f5361;
    font-weight: 500;
  }
}

.reset-filters {
  height: 34px;
  padding: 0 12px;
  color: #496372;
  border-color: #d9e4ea;
}

.factories-card {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(31, 73, 95, 0.14);
  border-radius: 8px;
  box-shadow: 0 14px 34px rgba(19, 55, 73, 0.12);
}

.factories-table {
  flex: 1;

  /deep/ th {
    padding: 8px 0 !important;
    background: #f5f8fa;
    color: #5b6873;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  /deep/ td {
    padding: 4px 0 !important;
    color: #4f5f69;
    border-bottom-color: #edf1f4;
  }

  /deep/ .cell {
    line-height: 22px;
    white-space: nowrap;
  }

  /deep/ .el-table__row {
    height: 33px;
  }

  /deep/ .el-table__fixed-right::before,
  /deep/ .el-table__fixed::before {
    background-color: #edf1f4;
  }

  /deep/ .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.98);
  }
}

.operation-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 24px;

  /deep/ .el-button {
    margin: 0;
    padding: 0;
    color: #167da0;
    font-weight: 600;
  }

  /deep/ .danger-action {
    color: #c8524b;
  }
}

.factories-pagination {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 48px;
  padding: 8px 12px;
  background: #fbfcfd;
  border-top: 1px solid #edf1f4;

  /deep/ .el-pagination {
    padding: 0;
    font-weight: 600;
    white-space: nowrap;
  }
}

@media (max-width: 768px) {
  .factories-shell {
    padding: 10px;
  }

  .factories-toolbar {
    align-items: stretch;
    flex-direction: column;

    h1 {
      font-size: 26px;
    }
  }

  .factories-filters {
    grid-template-columns: 1fr;
  }

  .factories-pagination {
    justify-content: flex-start;
    overflow-x: auto;
  }
}

</style>
